"use client";

import "./select.scss";

import AsyncSelect from "react-select/async";

import { Typography } from "../typography";

import styles from "./select.module.scss";
import { SelectProps } from "./select.types";

const Select = <OptionType,>({ errorMessage, colorTheme = "dark", ...props }: SelectProps<OptionType>) => {
  return (
    <div className={styles.select}>
      <AsyncSelect<OptionType>
        {...props}
        isSearchable
        isClearable
        classNamePrefix={`searchable-select--${colorTheme}`}
      />
      {errorMessage && (
        <Typography variant="caption-2" className={styles.typo}>
          {errorMessage}
        </Typography>
      )}
    </div>
  );
};

Select.displayName = "Select";

export { Select };
